var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center justify-center",staticStyle:{"height":"100vh"}},[_c('v-progress-circular',{attrs:{"size":80,"color":"primary","indeterminate":"","width":"6"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }